var exports = {
  "kL": "xf0b3b88a--0d151a--container",
  "my": "xf0b3b88a--0d151a--avatar",
  "Qs": "xf0b3b88a--0d151a--content",
  "DD": "xf0b3b88a--0d151a--title",
  "pq": "xf0b3b88a--0d151a--info",
  "p6": "xf0b3b88a--0d151a--date",
  "uf": "xf0b3b88a--0d151a--stars",
  "d4": "xf0b3b88a--0d151a--star",
  "qr": "xf0b3b88a--0d151a--footer",
  "Uo": "xf0b3b88a--0d151a--buttons",
  "MD": "xf0b3b88a--0d151a--reply_button",
  "Sx": "xf0b3b88a--0d151a--edit_button",
  "wy": "xf0b3b88a--0d151a--socnetwork",
};

module.exports = exports;
